// src/pages/LandingPage.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../components/Navbar";
import GlassSmileHero from "../components/GlassSmileHero";
import InfoSection from "../components/Assets";
import AboutSection from "../components/AboutSection";
import FeatureCards from "../components/FeatureCards";
import Doctors from "../components/Doctors";
import Comments from "../components/Comments";
import Map from "../components/Map";
import Footer from "../components/Footer";
import Seo, { SITE_URL } from "../components/Seo";


const LandingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white text-black min-h-screen">
      <Seo
        title={t("home.seo.title")}
        description={t("home.seo.description")}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Dentist",
          name: "Dt. Mert Sakarya Dental Clinic",
          url: SITE_URL,
        }}
      />

      {/* Navbar */}

      <Navbar />

      {/* Hero: "Camda Doğan Gülüş" 3D sahnesi */}
      <GlassSmileHero />

      {/* Güven veren rakamlar */}
      <InfoSection />

      {/* Hakkımızda bölümü */}


    <FeatureCards />
    
    
    <AboutSection />

      <Doctors />

      

      <Comments />

      <Map />

      <Footer />

    </div>
  );
};

export default LandingPage;
